import { Status } from '@common/config/api/client'

export const STUDY_STATUS_COLOR: Record<Status, string> = {
  STUDY_SETUP: 'secondary.dark',
  DRAFT: 'secondary.dark',
  UAT: 'secondary.main',
  LIVE: '#C9E8F2',
  COMPLETED: '#D7F5DB',
  ARCHIVED: 'warning-alt.main',
}

export const STUDY_STATUS_TEXT_COLOR: Record<Status, string> = {
  STUDY_SETUP: 'text.primary',
  DRAFT: 'text.primary',
  UAT: 'text.primary',
  LIVE: '#002530',
  COMPLETED: '#1B5E24',
  ARCHIVED: 'warning-alt.contrastText',
}
